export enum HighRiskCategory {
    "less_than_7" = 1,
    "event_cancelled",
    "pricing_issue",
    "low_availability"
}